<template>
	<Autocomplete
		v-model="selected"
		:icon="icon"
		:label="label"
		:name="name"
		:endpoint="endpoint"
		data-test="accounts-autocomplete"
		:item-title="
			(item: Api.Account) =>
				multiple
					? item.account_name?.hp_id
					: `${getAccountHpId(item.account_name?.hp_id).value} - ${item.account_name?.name}`
		"
		display-name="Konto"
		module="accounts"
		:multiple="multiple"
		v-bind="$attrs"
	>
		<template #item="{ item, props }">
			<v-list-item
				:title="`${getAccountHpId(item.raw.account_name?.hp_id).value} - ${item.raw.account_name?.name}`"
				v-bind="props"
			></v-list-item>
		</template>
	</Autocomplete>
</template>

<script setup lang="ts">
import Autocomplete from '@/components/templates/Validation/Autocomplete.vue'
import { getAccountHpId } from 'helpers/FormatValue.ts'

defineProps({
	icon: {
		default: '$accountDefault',
		type: String,
	},
	label: {
		default: 'Konten',
		type: String,
	},
	name: {
		default: 'accounts',
		type: String,
	},
	endpoint: {
		default: 'accounts',
		type: String,
	},
	multiple: {
		default: false,
		type: Boolean,
	},
})

const selected = defineModel<Api.Account>()
</script>

<style scoped></style>
